export const CUSTOMER_TAG_COLORS = [
  '#006C4E',
  '#287EAE',
  '#6D5BD0',
  '#A8549C',
  '#C65D3B',
  '#B7791F',
  '#667085',
] as const;

const HEX_COLOR = /^#[0-9a-f]{6}$/i;

export function customerTagColor(color: string | null | undefined): string {
  return color && HEX_COLOR.test(color) ? color : CUSTOMER_TAG_COLORS[0];
}
